import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import { useI18n } from "vue-i18n";

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

export function setupDayjsLocale(i18n: ReturnType<typeof useI18n>) {
  const { t } = i18n;

  dayjs.updateLocale("en", {
    relativeTime: {
      future: t("future", {
        time: "%s",
      }),
      past: t("past", {
        time: "%s",
      }),
      s: t("a-few-seconds"),
      m: t("1-minute"),
      mm: t("x-minutes", {
        number: "%d",
      }),
      h: t("1-hour"),
      hh: t("x-hours", {
        number: "%d",
      }),
      d: t("1-day"),
      dd: t("x-days", {
        number: "%d",
      }),
      M: t("1-month"),
      MM: t("x-months", {
        number: "%d",
      }),
      y: t("1-year"),
      yy: t("x-years", {
        number: "%d",
      }),
    },
  });
}
